/**
 * The legacy Stripe platform (slug `stripe`) only feeds reporting; Claude
 * reaches Stripe through the separate Stripe (MCP) platform (`stripe_mcp`).
 * Both used to show up as plain "Stripe", so the legacy one is relabelled
 * wherever it is listed.
 */
export const STRIPE_REPORTING_SLUG = 'stripe';

/** Whether a platform slug (or a connection's platform_key) is the legacy Stripe. */
export const isStripeReportingOnly = (key?: string | null): boolean =>
  key === STRIPE_REPORTING_SLUG;

/**
 * The name to show for a platform: the reporting-only label for the legacy
 * Stripe, otherwise the name it came with.
 */
export const platformDisplayName = (
  key: string | null | undefined,
  name: string,
  t: (key: string) => string
): string =>
  isStripeReportingOnly(key) ? t('Stripe-ReportingOnlyName') : name;
